// extracted by mini-css-extract-plugin
export default {"exampleMessage":"ExampleMessage_exampleMessage__q56l4","text":"ExampleMessage_text__vVzkZ","delete":"ExampleMessage_delete__cc6wI"};